import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useHomeWidgetStateQuery, {
	type useHomeWidgetStateQuery$data,
	type useHomeWidgetStateQuery$variables,
} from './__generated__/useHomeWidgetStateQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadHomeWidgets({ isLicensed }: { isLicensed: boolean }):
	| Promise<void>
	| Promise<{
			data: useHomeWidgetStateQuery$data | null;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }> {
	if (!isLicensed) {
		return Promise.resolve();
	}

	return query<useHomeWidgetStateQuery$data, useHomeWidgetStateQuery$variables>({
		query: useHomeWidgetStateQuery,
	});
}
